var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1000"
    },
    model: {
      value: _vm.errorDialog,
      callback: function ($$v) {
        _vm.errorDialog = $$v;
      },
      expression: "errorDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5 red darken-4"
  }, [_vm._v(" Hibás kontrollerek ")]), _c('v-card-text', [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _c('th', [_vm._v("Név")]), _c('th', [_vm._v("IP")]), _c('th', [_vm._v("Szériaszám")]), _c('th', [_vm._v("Idő")])])]), _c('tbody', _vm._l(_vm.unreachableControllers, function (controller) {
          return _c('tr', {
            key: controller.id
          }, [_c('td', [_vm._v(_vm._s(controller.elementId))]), _c('td', [_vm._v(_vm._s(controller.name))]), _c('td', [_vm._v(_vm._s(controller.ip))]), _c('td', [_vm._v(_vm._s(controller.serialNumber))]), _c('td', [_vm._v(_vm._s(controller.time))])]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('update:errorDialog', false);
      }
    }
  }, [_vm._v(" Rendben ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }